export default __webpack_public_path__ + "static/media/ic-panelist-icon.2f453f57.svg";